/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CountriesResponseGetRecordsList } from '../../models/countries-response-get-records-list';

export interface LocationsControllerGetCountries$Params {
}

export function locationsControllerGetCountries(http: HttpClient, rootUrl: string, params?: LocationsControllerGetCountries$Params, context?: HttpContext): Observable<StrictHttpResponse<CountriesResponseGetRecordsList>> {
  const rb = new RequestBuilder(rootUrl, locationsControllerGetCountries.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CountriesResponseGetRecordsList>;
    })
  );
}

locationsControllerGetCountries.PATH = '/planning-projects/v1/locations/countries';
